export enum KillOutcomeType {
  SingleKill = "single_kill",
  DoubleKill = "double_kill",
  NoKill = "no_kill",
  BackfireKill = "backfire_kill",
}

export interface KillBattleSpentAsset {
  label: string;
  value: string;
  iconSrc?: string;
}

export interface KillBattleLootReward {
  id: string;
  label: string;
  value: string;
  iconSrc: string;
  note?: string;
}

export interface KillBattleRewards {
  rankXp: number;
  killXp: number;
  loot: KillBattleLootReward[];
}

export interface KillOutcomePlayerAvatars {
  attacker: string;
  victim: string;
}

export interface KillBattleOutcome {
  id: string;
  location: string;
  attackerName: string;
  attackerAddress: string;
  victimName: string;
  victimAddress: string;
  attackerBullets: number;
  victimBullets?: number;
  weaponName: string;
  weaponImage?: string;
  outcomeType: KillOutcomeType;
  storyIndex: number;
  attackerHealthLost?: number;
  victimHealthLost?: number;
  spentAssets?: KillBattleSpentAsset[];
  rewards: KillBattleRewards;
  transactionHash?: string;
  killId?: string;
  rewardsClaimed: boolean;
}
